import { render } from "./AppMainSection.vue?vue&type=template&id=427ca3d5"
import script from "./AppMainSection.vue?vue&type=script&lang=js"
export * from "./AppMainSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__